export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 64;
